import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { SelectionItem, SelectionResponse } from "models/utilTypes/selectionTypes";
import { InputSuggestionsProps } from "models/propTypes/inputPropTypes";
import { DialogEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import Icon from "../../icon";
import RoundButton from "../../buttons/roundButton";
import AutoGeneratedMessage from "../../messages/autoGeneratedMessage";
import { Chip, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";

const InputSuggestions: React.FC<InputSuggestionsProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onSuggestionSelect = (selectedItem: SelectionItem, e: React.MouseEvent<HTMLDivElement>) => {
    props.onChange(selectedItem);
  };

  const onDisplayDialog = () => {
    props.form &&
      dispatch(
        displayDialog({
          isOpen: false,
          title: props.form.title,
          subTitle: props.form.subTitle,
          titleIcon: props.form.titleIcon,
          dialogType: DialogEnums.DialogType.Content,
          actions: [
            {
              text: LocalizationHelperInstance.getFormattedMessage("Common.SaveChanges"),
            },
          ],
          fullWidth: true,
          children: props.form.form,
          onSubmit: onFormSubmit,
        })
      );
  };

  const onFormSubmit = (values?: any) => {
    const response = values as SelectionResponse;
    props.onFormSubmit && props.onFormSubmit(response);
  };

  return (
    <Grid item container className={clsx(cssExports.suggestionsChips, cssExports.selectionChipsGroup)} spacing={1}>
      <Grid item container className={cssExports.selectionChips} spacing={1} direction="row">
        {props.suggestions ? (
          props.suggestions.map((item) => (
            <Grid item key={item.id} className={cssExports.chipContainer}>
              <Chip
                className={clsx(cssExports.chip)}
                variant="outlined"
                data-key={item.id}
                label={item.value}
                clickable
                onClick={onSuggestionSelect.bind(null, item)}
              />
            </Grid>
          ))
        ) : (
          <></>
        )}
        {(props.onAddButtonClick || props.form) && (
          <Grid item>
            <RoundButton size="sm" onClick={props.onAddButtonClick || (props.form && onDisplayDialog)}>
              <Icon icon={IconDefinitionConstants.WPlus} />
            </RoundButton>
          </Grid>
        )}
      </Grid>
      {props.autogeneratedText && props.suggestions && props.suggestions.length > 0 && (
        <Grid item container>
          <AutoGeneratedMessage className={cssExports.suggestionsChipsAutogeneratedMessage}>
            {props.autogeneratedText}
          </AutoGeneratedMessage>
        </Grid>
      )}
    </Grid>
  );
};

export default InputSuggestions;
